import { sortBy } from '@dhl/utils'

type WithName = {
  name: string
}

export const sortByName = <T extends WithName>(a: T, b: T) => (a.name.toLowerCase() <= b.name.toLowerCase() ? -1 : 1)

/* Conditionally insert array elements, usage:
    const arr = [
      ...insertIf(true, {x:1}),
      {y:2},
    ]
    ===>
    [{x:1},{y:2}]
 */
export const insertIf = <T>(condition: boolean, ...elements: T[]) => {
  return condition ? elements : []
}

export const sortArrayByPreference = <T extends string | number>(input: T[], preference: T[]) => {
  const last = input.length

  return sortBy(input, (item) => (preference.indexOf(item) !== -1 ? preference.indexOf(item) : last))
}

export const groupByCondition = <T>(arr: T[], condition: (item: T, index: number) => number): T[][] =>
  arr.reduce<T[][]>((result, item, index) => {
    const group = condition(item, index)
    if (!result[group]) {
      result[group] = []
    }
    result[group].push(item)

    return result
  }, [])

export const isEmptyArray = (input: unknown[] | null | undefined): input is [] =>
  Array.isArray(input) && input.length === 0
